import { initial } from "@/api/app";
import { useStateStore } from "@/stores/app/state";
import { ref } from "vue";

export default () => {
  const isFetching = ref(false);
  const stateStore = useStateStore();

  const success = async (response) => {
    if (response.status != 200) {
      return false;
    }

    // set app data here
  };

  const failed = async (error) => {
    console.log(error);
  };

  const execute = async () => {
    isFetching.value = true;
    stateStore.setFetched(false);
    await initial().then(success, failed);
    stateStore.setFetched(true);
    isFetching.value = false;
  };

  return {
    execute,
    isFetching,
  };
};
